export function extractWaypoints(scenes) {
  var wp = []
  for (var k = 0; k < scenes.length; k++) {
    var scene = scenes[k]
    var hwps = scene.waypoints
    let waypoints = []
    // add virtual waypoint for scene that has only 1, so that there is a time span where the interpolator
    // spans up some frames to trigger on and off of the tag
    if (hwps.length === 1) {
      waypoints = hwps.slice(0)
      let wp1 = Object.assign({}, hwps[0])
      wp1.time += 0.05
      wp1.timeAsFragment = wp1.time * 20 // magic number 20, see framerate in utils.extractWaypoints
      waypoints.push(wp1)
    } else {
      waypoints = hwps
    }

    for (var l = 0; l < waypoints.length; l++) {
      var waypoint = waypoints[l]
      waypoint.timeAsFragment = Math.round(waypoint.time * 20)
      waypoint.last = waypoints[l - 1] ? waypoints[l - 1].id : null
      waypoint.next = waypoints[l + 1] ? waypoints[l + 1].id : null
      wp.push(waypoint)
    }
  }
  return wp
}
export function groupBy(xs, key) {
  return xs.reduce(function (rv, x) {
    (rv[x[key]] = rv[x[key]] || []).push(x)
    return rv
  }, {})
}
export function interpolate(a, b, frac) {
  if (!Number.isFinite(frac)) {
    frac = 0.01;
  }
  // console.log('interpolate: ', a, b, frac)
  return {
    x: a.x + (b.x - a.x) * frac,
    y: a.y + (b.y - a.y) * frac,
    w: a.w + (b.w - a.w) * frac,
    h: a.h + (b.h - a.h) * frac,
    pw: a.pw + (b.pw - a.pw) * frac,
    ph: a.ph + (b.ph - a.ph) * frac
  }
}

export function whiteColor() {
  return {
    r: 255,
    g: 255,
    b: 255,
    a: 1
  }
}

export function blackColor() {
  return {
    r: 0,
    g: 0,
    b: 0,
    a: 1
  }
}

export function transparentColor() {
  return {
    r: 255,
    g: 255,
    b: 255,
    a: 0
  }
}

export const boxSizes = {
  0: 'bs-xs',
  1: 'bs-s',
  2: 'bs-m',
  3: 'bs-l',
  4: 'bs-xl'
}

export const tAligns = {
  't-left': 'left',
  't-center': 'center',
  't-right': 'right',
  't-justify': 'justify'
}

export const vAligns = {
  'v-top': 'flex-start',
  'v-center': 'center',
  'v-bottom': 'flex-end'
}

export const hAligns = {
  'h-left': 'flex-start',
  'h-center': 'center',
  'h-right': 'flex-end'
}

export function evaluateButtonContentStyles(dimensions, fontBaseSize) {
  console.log("evaluateButtonContentStyles")
  let w = dimensions.w
  let fs = fontBaseSize; // default base is 12
  if (w < 640) {
    fs = fontBaseSize / 12 * 8;
  } else if (w >= 640 && w < 960) {
    fs = fontBaseSize
  } else if (w >= 960 && w < 1200) {
    fs = fontBaseSize / 12 * 14
  } else {
    fs = fontBaseSize / 12 * 16
  }
  return {
    fontSize: `${fs}pt`
  }
}

/**
 * Evaluates all the styles to apply to an quiz answer based on dimensions, layout and number of options
 * Goal is to have an optimized representation of the answer
 */
export function evaluateQuizAnswerBoxStyles(answers, dimensions, layout) {
  var styles = lookupStyles(answers, dimensions, layout, 'qabs')
  console.log("evaluateQuizAnswerBoxStyles", styles, answers, dimensions, layout)
  return styles
}

export function evaluateQuizBoxStyles(answers, dimensions, layout) {
  var styles = lookupStyles(answers, dimensions, layout, 'qbs')
  console.log("evaluateQuizBoxStyles", styles, answers, dimensions, layout)
  return styles
}

function lookupStyles(answers, dimensions, layout, type) {
  let lay = layout === 'h-layout' ? 'h' : 'v'
  var defaults = quizStyles[`${lay}-default`][type]
  for (var i = 0; i < breakPoints.length; i++) {
    var bp = breakPoints[i]
    if (dimensions.w >= bp.min && dimensions.w < bp.max) {
      // key for matching styles
      key = `${lay}-${bp.min}-${bp.max}`
      console.log("using key %s", key)
      var base = quizStyles[key] ? quizStyles[key][type] : null
      // overrides that takes number of options into account
      var key = `${lay}-${bp.min}-${bp.max}-${answers.length}`
      console.log("using key %s", key)
      var overrides = quizStyles[key] ? quizStyles[key][type] : null
      return Object.assign({}, defaults, Object.assign({}, base, overrides))
    }
  }
}

export function getTextFromMultiLang(field, lang) {
  if (!field || typeof field === 'string') {
    return field || ''
  } else {
    return field[lang]
  }
}

/**
 * Break points to use based on the dimensions of the video player (not the viewport!),
 * this will be used to get the mapping for respective the quizStyles map value.
 */
const breakPoints = [{
    max: 9999,
    min: 1300
  },
  {
    max: 1300,
    min: 1000

  },
  {
    max: 1000,
    min: 800

  },
  {
    max: 800,
    min: 600
  },
  {
    max: 600,
    min: 0
  }
]

/**
 * Dynamic styles to be applied to the quiz and its answers based on the dimensions of
 * the player (not the viewport), the layout and the number of options.
 */
const quizStyles = {
  // vertical defaults
  'v-default': {
    'qbs': {
      'width': '100%',
      'fontSize': '14pt'
    },
    'qabs': {
      'margin': '0.5em',
      'fontSize': '1em',
      'width': '100%',
      'padding': '1.5em'
    }
  },
  'v-1300-9999': {
    'qbs': {
      'width': '65%'
    }
  },
  'v-1000-1300': {
    'qbs': {
      'width': '75%',
      'fontSize': '13pt'
    }
  },
  'v-800-1000': {
    'qbs': {
      'width': '85%',
      'fontSize': '12pt'
    }
  },
  'v-600-800': {
    'qbs': {
      'width': '95%',
      'fontSize': '11pt'
    }
  },
  'v-0-600': {
    'qbs': {
      'width': '95%',
      'fontSize': '8pt',
      'padding': '0em'
    },
    'qabs': {
      'margin': '0.1em',
      'padding': '0.1em'
    }
  },
  // horiziontal defaults
  'h-default': {
    'qbs': {
      'width': '100%',
      'fontSize': '14pt'
    },
    'qabs': {
      'margin': '1em',
      'fontSize': '1em',
      'width': '28%',
      'padding': '1em'
    }
  },
  // h wide screens
  'h-1300-9999': {
    'qbs': {
      '-width': '80%',
      'fontSize': '13pt'
    },
    'qabs': {
      'width': '28%'
    }
  },
  'h-1300-9999-4': {
    'qbs': {
      '-width': '80%'
    },
    'qabs': {
      'width': '45%'
    }
  },
  // h large screens
  'h-1000-1300': {
    'qbs': {
      'fontSize': '13pt'
    },
    'qabs': {
      'width': '45%'
    }
  },
  // h medium screens
  'h-800-1000': {
    'qbs': {
      'fontSize': '12pt'
    },
    'qabs': {
      'width': '45%'
    }
  },
  'h-800-1000-5': {
    'qabs': {
      'width': '28%'
    }
  },
  // h small screens
  'h-600-800': {
    'qbs': {
      'fontSize': '10pt',
      'padding': '0em'
    },
    'qabs': {
      'margin': '0.5em',
      'padding': '0.5em',
      'width': '45%'
    }
  },
  'h-600-800-5': {
    'qabs': {
      'width': '28%'
    }
  },
  // h tiny screens
  'h-0-600': {
    'qbs': {
      'fontSize': '8pt',
      'padding': '0em'
    },
    'qabs': {
      'padding': '0em',
      'width': '40%'
    }
  },
  'h-0-600-5': {
    'qbs': {
      'width': '100%',
      'fontSize': '8pt',
      'padding': '0em'
    },
    'qabs': {
      'margin': '0.1em',
      'width': '29%',
      'padding': '0.1em'
    }
  }
}
